export default __webpack_public_path__ + "static/media/spacing-vertical.b557f67f.svg";